import { Stack } from '@amboss/design-system';
import { Form, Formik } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../config';
import { useAppSelector } from '../../../../hooks/redux';
import useCreditsPaginate from '../../../../hooks/useCreditsPaginate';
import { creditsTypeSelector } from '../../../../store/credits/creditsSlice';
import { isCourseCreditType } from '../../../../utils';
import EmptyPlaceholder from '../../../atoms/EmptyPlaceholder';
import CourseReviewedList from '../lists/CourseReviewedList';
import ReviewedList from '../lists/ReviewedList';

const ReviewedTab = () => {
  const { t } = useTranslation();
  const creditType = useAppSelector(creditsTypeSelector);

  const { isLoading, credits, refreshCredits } = useCreditsPaginate(config.tabs.REVIEWED);

  useEffect(() => {
    refreshCredits();
  }, []);

  return (
    <>
      {!isLoading && (
        <Formik
          initialValues={{ creditIds: [], rating: {} }}
          onSubmit={(values, actions) => {}}
        >
          <Form>
            {isCourseCreditType(creditType) ? (
              <CourseReviewedList credits={credits} />
            ) : (
              <ReviewedList credits={credits} />
            )}
          </Form>
        </Formik>
      )}
      {isLoading && (
        <Stack space={'m'}>
          <EmptyPlaceholder
            header={t('loading.header')}
            subHeader={t('loading.subheader')}
          />
        </Stack>
      )}
    </>
  );
};

export default ReviewedTab;
